import { SafeUrl } from '@angular/platform-browser';

export class FeaturedAdModel {
	featuredAdImage: string;
	imageURL: SafeUrl;
	adClickURL: string;
	company: string;
}
